exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full[data-v-6e4ab61c]{height:100%;width:100%}.center-title[data-v-6e4ab61c]{text-align:center}.yo-btn[data-v-6e4ab61c],.yo-btn[data-v-6e4ab61c]:hover{-webkit-box-shadow:none;box-shadow:none;text-shadow:none;background-color:#fff;background-image:none}.marginer[data-v-6e4ab61c]{margin:30px}.warn[data-v-6e4ab61c]{color:red}@media screen and (min-width:767px){.hide-desktop[data-v-6e4ab61c]{display:none}}", ""]);

// exports
